var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-cbt-add-modal-component" }, [
    _c("div", { staticClass: "room-cbt-add-modal flex flex-col" }, [
      _c(
        "div",
        { staticClass: "room-cbt-add-modal-header" },
        [
          _c("h6", [_vm._v("문제집 상세 정보")]),
          _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "mt-6 flex flex-col gap-4 min-h-0 flex-1 overflow-hidden",
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col gap-2" },
            [
              _vm._m(0),
              _c("GrmTextField", {
                staticClass: "w-full",
                attrs: {
                  value: _vm.selectedCBT.cbtTitle,
                  size: "xs",
                  disabled: "",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex flex-col gap-2" },
            [
              _vm._m(1),
              _c("GrmTextField", {
                staticClass: "w-full",
                attrs: {
                  value: _vm.getRoomDocFile({
                    docId: _vm.selectedCBT.docId,
                    roomGroupId: "default",
                  }).docName,
                  size: "xs",
                  disabled: "",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-2 min-h-0 flex-1 overflow-y-auto",
            },
            [
              _c("div", { staticClass: "h-8 flex items-center gap-2" }, [
                _c("p", { staticClass: "font-bold" }, [
                  _vm._v("문항 수 및 문항별 정답"),
                ]),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-1" },
                  [
                    _c("GrmTextField", {
                      staticClass: "w-16",
                      attrs: {
                        type: "number",
                        value: _vm.selectedCBT.questionCnt,
                        size: "xs",
                        disabled: "",
                      },
                    }),
                    _c("span", { staticClass: "text-sm" }, [_vm._v("개")]),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "p-2 min-h-0 flex-1 overflow-y-auto relative" },
                _vm._l(_vm.selectedCBT.questionList, function (cbtQuestion, i) {
                  return _c(
                    "div",
                    {
                      key: cbtQuestion.questionId,
                      staticClass: "flex items-center gap-1",
                      class:
                        i !== 0 &&
                        (i + 1) % cbtQuestion.answerList.length === 0 &&
                        i + 1 !== _vm.selectedCBT.questionCnt
                          ? "border-b pb-3 mb-3"
                          : "",
                    },
                    [
                      _c("span", { staticClass: "w-8 text-sm inline-block" }, [
                        _vm._v(_vm._s(_vm.number(i + 1)) + "."),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-0.5" },
                        _vm._l(cbtQuestion.answerList, function (answer, j) {
                          return _c(
                            "div",
                            {
                              key: answer.answerOrder,
                              staticClass:
                                "w-4 h-4 rounded-full text-xs flex justify-center items-center",
                              class: answer.correct ? "bg-black" : "border",
                            },
                            [_vm._v(_vm._s(j + 1))]
                          )
                        }),
                        0
                      ),
                      _c(
                        "div",
                        { staticClass: "flex items-center text-sm" },
                        [
                          _vm._v(" ("),
                          _c("GrmTextField", {
                            staticClass: "w-10",
                            attrs: {
                              type: "number",
                              value: cbtQuestion.questionScore,
                              size: "2xs",
                              disabled: "",
                            },
                          }),
                          _c("span", { staticClass: "text-sm" }, [
                            _vm._v("점)"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "flex items-center gap-2" },
            [
              _c("div", { staticClass: "flex items-center gap-1" }, [
                _c(
                  "div",
                  { staticClass: "flex items-center" },
                  [
                    _c("GrmTextField", {
                      staticClass: "w-14 mr-1 flex",
                      attrs: {
                        type: "number",
                        textalign: "right",
                        size: "xs",
                        min: 0,
                        max: 23,
                      },
                      model: {
                        value: _vm.hours,
                        callback: function ($$v) {
                          _vm.hours = $$v
                        },
                        expression: "hours",
                      },
                    }),
                    _c("p", { staticClass: "text-sm" }, [
                      _vm._v(_vm._s(_vm.$t("common.hour"))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "ml-3 flex items-center" },
                  [
                    _c("GrmTextField", {
                      staticClass: "w-14 mr-1 flex",
                      attrs: {
                        type: "number",
                        textalign: "right",
                        size: "xs",
                        min: 0,
                        max: 59,
                      },
                      model: {
                        value: _vm.minutes,
                        callback: function ($$v) {
                          _vm.minutes = $$v
                        },
                        expression: "minutes",
                      },
                    }),
                    _c("p", { staticClass: "text-sm" }, [
                      _vm._v(_vm._s(_vm.$t("common.minute"))),
                    ]),
                  ],
                  1
                ),
              ]),
              _c(
                "GrmBtn",
                {
                  staticClass: "min-w-0 flex-1",
                  on: { click: _vm.onStartCBT },
                },
                [_vm._v("전자문제집 출제")]
              ),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "h-8 flex items-center" }, [
      _c("p", { staticClass: "font-bold" }, [_vm._v("제목")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "h-8 flex items-center" }, [
      _c("p", { staticClass: "font-bold" }, [_vm._v("문제집")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }